// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__B7UXq","info":"Note_info__2Cx7t","note":"Note_note__2IFs6","actions":"Note_actions__19-KN"};